import { getMyAutomatedChatSetting, setAutomatedChatEnabled } from "./automatedChatService";

// Module-level singleton so every useAutomatedChat() consumer reads/writes the
// same state instead of each holding its own stale copy, same shape as presenceStore.
let state = { enabled: null, loading: true };
let started = false;
const listeners = new Set();

const setState = (partial) => {
    state = { ...state, ...partial };
    listeners.forEach((listener) => listener());
};

export const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const getSnapshot = () => state;

export const start = () => {
    if (started) return;
    started = true;
    refresh();
};

export const refresh = async () => {
    try {
        const { data } = await getMyAutomatedChatSetting();
        setState({ enabled: data?.enabled ?? false, loading: false });
    } catch (err) {
        console.error("[useAutomatedChat] failed to load setting", err);
        setState({ loading: false });
    }
};

let updateRequestId = 0;

export const updateEnabled = async (newValue) => {
    const previous = state.enabled;
    const myRequestId = ++updateRequestId;
    setState({ enabled: newValue });
    try {
        await setAutomatedChatEnabled(newValue);
    } catch (err) {
        console.error("[useAutomatedChat] failed to update setting", err);
        // Ignore a stale response - a newer call already updated state.
        if (myRequestId === updateRequestId) {
            setState({ enabled: previous });
        }
    }
};
